import { usePageTitle } from '@app/hooks/usePageTitle';
import { ReactNode } from 'react';

interface PageWrapperProps {
  title: ReactNode;
  children: ReactNode;
}

/**
 * A simple wrapper component that sets the page title and renders children
 * Useful for pages that need to set a title without creating a separate component
 */
export const PageWrapper = ({ title, children }: PageWrapperProps) => {
  usePageTitle(title);
  return <>{children}</>;
};

export default PageWrapper;
